import {ProcessOverviewComponent} from '../views/process-overview/process-overview.component';
import {GoToTrapoComponent} from '../views/go-to-trapo/go-to-trapo.component';
import {EpostConfigWrapperComponent} from '../views/epost-config/epost-config-wrapper/epost-config-wrapper.component';
import {DunningConfigComponent} from '../views/dunning-config/dunning-config.component';
import {TariffChangesComponent} from '../views/tariff-changes/tariff-changes.component';
import {AlternativePayerTableComponent} from '../views/payer-overview/alternative-payer-table.component';
import {PayerOverviewComponent} from '../views/payer-overview/payer-overview.component';
import {ConfigurationOverviewComponent} from '../views/configuration-overview/configuration-overview.component';
import {ItemTableComponent} from '../views/hidden-views/item-table.component';
import {PayerTableComponent} from '../views/hidden-views/payer-table.component';
import {InvoiceTemplateTableComponent} from '../views/hidden-views/invoice-template-table.component';
import {CollectiveinvoiceTableComponent} from '../views/hidden-views/collectiveinvoice-table.component';
import {CarttypeTableComponent} from '../views/hidden-views/carttype-table.component';
import {AddressinfoTableComponent} from '../views/hidden-views/addressinfo-table.component';
import {ItemPriceMappingTableComponent} from '../views/hidden-views/item-price-mapping-table.component';
import {InvoiceTemplateConfigFormComponent} from '../views/hidden-views/invoice-template-config-form.component';
import {GlobalTemplateConfigFormComponent} from '../views/hidden-views/global-template-config-form.component';
import {DtaServiceConflictTableComponent} from '../views/dta-service-conflict-table.component';
import {GuidFormComponent, GuidTableComponent, UserListComponent} from 'frontier';
import {TariffOptionsComponent} from '../views/tariff-changes/tariff-options/tariff-options.component';
import {
  OpenItemImportConfigFormComponent
} from '../views/configuration-overview/open-item-import-config-form/open-item-import-config-form.component';
import {
  BookingOptionsConfigFormComponent
} from '../views/configuration-overview/booking-options-config-form/booking-options-config-form.component';
import {
  CustomerBaseDataConfigFormComponent
} from '../views/configuration-overview/customer-basedata-config-form/customer-base-data-config-form.component';
import {OnboardingOverviewComponent} from '../views/onboarding-overview/onboarding-overview.component';
import {ItemGroupBaseTableComponent} from '../views/hidden-views/item-group-base-table.component';
import {ItemGroupTypeTableComponent} from '../views/hidden-views/item-group-type-table.component';
import {DataOfficeBaseTableComponent} from '../views/hidden-views/data-office-base-table.component';
import {BusinessAreasTableComponent} from '../views/hidden-views/business-areas-table.component';
import {
  BaseInvoiceTemplateConfigTableComponent
} from '../views/hidden-views/base-invoice-template-config-table.component';
import {PayerHiddenTableComponent} from '../views/payer-overview/payer-hidden-table.component';
import {MissionDataCollectionComponent} from '../views/mission-data-collection/mission-data-collection.component';
import {
  VerificationRulesConfigFormComponent
} from '../views/configuration-overview/verification-rules-config-form/verification-rules-config-form.component';
import {RescueStationComponent} from '../views/rescue-station/rescue-station.component';
import {BillingEvaluationsComponent} from '../views/billing-evaluations/billing-evaluations.component';
import {MetabaseDashboardComponent} from '../views/metabase-dashboard/metabase-dashboard.component';
import {MetabaseDashboardWrapperComponent} from '../views/metabase-dashboard/metabase-dashboard-wrapper.component';
import {HelpViewComponent} from '../views/help-view/help-view.component';
import {
  ConditionTableComponent
} from '../views/configuration-overview/verification-rules-config-form/condition-rules-table.component';
import {Trapo2Component} from '../views/trapo2/trapo2.component';
import {CartHnrImportTableComponent} from '../views/cart-hnr-import-table/cart-hnr-import-table.component';
import {CartImportTableComponent} from '../views/cart-import-table/cart-import-table.component';
import {ClientHnrImportTableComponent} from '../views/client-hnr-import-table/client-hnr-import-table.component';
import {
  GlobalCustomerSettingsFormComponent
} from '../views/global-customer-settings-form/global-customer-settings-form.component';
import {TemplatesEditorComponent} from '../views/template-editor/templates-editor.component';
import {ChangeLogComponent} from '../views/change-log/change-log.component';
import {LetterOfResignationComponent} from '../views/letter-of-resignation/letter-of-resignation.component';
import {DunningsEditorComponent} from '../views/template-editor/dunnings-editor.component';
import {LanguageConfigComponent} from '../views/language-config/language-config.component';
import {LanguageTableComponent} from '../views/language-config/language-table.component';
import {TranslationTableComponent} from '../views/language-config/translation-table.component';
import {
  DunningLevelImportTableComponent
} from '../views/onboarding-overview/dunning-level-import-table/dunning-level-import-table.component';
import {
  DunningConfigImportTableComponent
} from '../views/onboarding-overview/dunning-config-import-table/dunning-config-import-table.component';
import {
  ConfigLanguageImportTableComponent
} from '../views/onboarding-overview/config-language-import-table/config-language-import-table.component';
import {
  DictionaryImportTableComponent
} from '../views/onboarding-overview/dictionary-import-table/dictionary-import-table.component';
import {
  LanguageImportTableComponent
} from '../views/onboarding-overview/language-import-table/language-import-table.component';
import {
  InvoiceAutomationEditorComponent
} from '../views/template-editor/invoice-automation-editor.component';
import {
  InvoiceAutomationImportComponent
} from '../views/onboarding-overview/invoice-automation-import/invoice-automation-import.component';
import {VehicleComponent} from "../views/vehicle/vehicle.component";
import {DashboardV2Component} from '../views/dashboard-v2/dashboard-v2.component';

export const ComponentRegistry: { [key: string]: any } = {
  'AddressinfoTableComponent': AddressinfoTableComponent,
  'AlternativePayerTableComponent': AlternativePayerTableComponent,
  'BaseInvoiceTemplateConfigTableComponent': BaseInvoiceTemplateConfigTableComponent,
  'BillingEvaluationsComponent': BillingEvaluationsComponent,
  'BookingOptionsConfigFormComponent': BookingOptionsConfigFormComponent,
  'BusinessAreasTableComponent': BusinessAreasTableComponent,
  'CartHnrImportTableComponent': CartHnrImportTableComponent,
  'CartImportTableComponent': CartImportTableComponent,
  'CarttypeTableComponent': CarttypeTableComponent,
  'ChangeLogComponent': ChangeLogComponent,
  'ClientHnrImportTableComponent': ClientHnrImportTableComponent,
  'CollectiveinvoiceTableComponent': CollectiveinvoiceTableComponent,
  'ConditionTableComponent': ConditionTableComponent,
  'ConfigLanguageImportTableComponent': ConfigLanguageImportTableComponent,
  'ConfigurationOverviewComponent': ConfigurationOverviewComponent,
  'CustomerBasedataConfigFormComponent': CustomerBaseDataConfigFormComponent,
  'DashboardV2Component': DashboardV2Component,
  'DataOfficeBaseTableComponent': DataOfficeBaseTableComponent,
  'DictionaryImportTableComponent': DictionaryImportTableComponent,
  'DtaServiceConflictTableComponent': DtaServiceConflictTableComponent,
  'DunningConfigComponent': DunningConfigComponent,
  'DunningConfigImportTableComponent': DunningConfigImportTableComponent,
  'DunningsEditorComponent': DunningsEditorComponent,
  'DunningLevelImportTableComponent': DunningLevelImportTableComponent,
  'EpostConfigWrapperComponent': EpostConfigWrapperComponent,
  'GlobalCustomerSettingsFormComponent': GlobalCustomerSettingsFormComponent,
  'GlobalTemplateConfigFormComponent': GlobalTemplateConfigFormComponent,
  'GoToTrapoComponent': GoToTrapoComponent,
  'GuidFormComponent': GuidFormComponent,
  'GuidTableComponent': GuidTableComponent,
  'HelpViewComponent': HelpViewComponent,
  'InvoiceAutomationEditorComponent': InvoiceAutomationEditorComponent,
  'InvoiceAutomationImportComponent': InvoiceAutomationImportComponent,
  'InvoiceTemplateConfigFormComponent': InvoiceTemplateConfigFormComponent,
  'InvoiceTemplateTableComponent': InvoiceTemplateTableComponent,
  'ItemGroupBaseTableComponent': ItemGroupBaseTableComponent,
  'ItemGroupTypeTableComponent': ItemGroupTypeTableComponent,
  'ItemPriceMappingTableComponent': ItemPriceMappingTableComponent,
  'ItemTableComponent': ItemTableComponent,
  'LanguageConfigComponent': LanguageConfigComponent,
  'LanguageImportTableComponent': LanguageImportTableComponent,
  'LanguageTableComponent': LanguageTableComponent,
  'LetterOfResignationComponent': LetterOfResignationComponent,
  'MetabaseDashboardComponent': MetabaseDashboardComponent,
  'MetabaseDashboardWrapperComponent': MetabaseDashboardWrapperComponent,
  'MissionDataCollectionComponent': MissionDataCollectionComponent,
  'OnboardingOverviewComponent': OnboardingOverviewComponent,
  'OpenItemImportConfigFormComponent': OpenItemImportConfigFormComponent,
  'PayerHiddenTableComponent': PayerHiddenTableComponent,
  'PayerOverviewComponent': PayerOverviewComponent,
  'PayerTableComponent': PayerTableComponent,
  'ProcessOverviewComponent': ProcessOverviewComponent,
  'RescueStationComponent': RescueStationComponent,
  'TariffChangesComponent': TariffChangesComponent,
  'TariffOptionsComponent': TariffOptionsComponent,
  'TemplatesControl': TemplatesEditorComponent,
  'TranslationTableComponent': TranslationTableComponent,
  'Trapo2Component': Trapo2Component,
  'UserListComponent': UserListComponent,
  'VehicleComponent': VehicleComponent,
  'VerificationRulesConfigFormComponent': VerificationRulesConfigFormComponent,
  // Add other components here
};
